import React from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

interface FormTabsProps {
  tab: 'userDetails';
  add: boolean;
  onTabChange: (e: any, value: 'userDetails') => void;
}

const FormTabs: React.FC<FormTabsProps> = ({ tab, add, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor="primary">
        <Tab value="userDetails" label={t('users.addEdit.pageTexts.form.tabs.userDetails')} />
      </Tabs>
    </div>
  );
};

export default FormTabs;
